const fragmentShader4 = `
// #extension GL_OES_standard_derivatives : enable

precision highp float;

uniform float time;
uniform float frequency;
uniform float amplitude;
uniform vec3 color;

varying vec3 fPosition;
varying vec3 fNormal;
varying vec3 oPosition;

mat3 cotangent_frame( vec3 N, vec3 p, vec2 uv )
{
    // get edge vectors of the pixel triangle
    vec3 dp1 = dFdx( p );
    vec3 dp2 = dFdy( p );
    vec2 duv1 = dFdx( uv );
    vec2 duv2 = dFdy( uv );
 
    // solve the linear system
    vec3 dp2perp = cross( dp2, N );
    vec3 dp1perp = cross( N, dp1 );
    vec3 T = dp2perp * duv1.x + dp1perp * duv2.x;
    vec3 B = dp2perp * duv1.y + dp1perp * duv2.y;
 
    // construct a scale-invariant frame 
    float invmax = inversesqrt( max( dot(T,T), dot(B,B) ) );
    return mat3( T * invmax, B * invmax, N );
}

vec3 perturb_normal( vec3 N, vec3 V, vec2 texcoord, vec3 P )
{
    vec3 map = vec3(amplitude*cos(-P.x*frequency + time * 4.), 1.0, 1.0);
    mat3 TBN = cotangent_frame( N, -V, texcoord );
    return normalize( TBN * map );
}

vec3 rim(vec3 color, float start, float end, float coef)
{
  vec3 normal = normalize(fNormal);
  vec3 eye = normalize(-fPosition.xyz);
  float rim = smoothstep(start, end, 1.0 - dot(normal, eye));
  return clamp(rim, 0.0, 1.0) * coef * color;
}

vec2 blinnPhongDir(vec3 N, vec3 lightDir, float lightInt, float Ka, float Kd, float Ks, float shininess)
{
  vec3 s = normalize(lightDir);
  vec3 v = normalize(-fPosition);
  vec3 n = normalize(N);
  vec3 h = normalize(v+s);
  float diffuse = Ka + Kd * lightInt * max(0.0, dot(n, s));
  float spec =  Ks * pow(max(0.0, dot(n,h)), shininess);
  return vec2(diffuse, spec);
}

void main()
{
  vec3 N = normalize(fNormal);
  vec3 V = normalize(-fPosition);
  N = perturb_normal(N, V, gl_FragCoord.xy, oPosition);
  vec3 rimi = rim(vec3(1.0,0.5,0.0), 0.2, 0.9, 1.0);
  vec2 blin = blinnPhongDir(N, vec3(1.0,1.0,1.0), 1.0, 0.3, 0.6, 0.6, 42.0);
  vec3 c = color * blin.x + blin.y;
  gl_FragColor = vec4(c, 1.0);
}
`;

export default fragmentShader4;
